import styled from "styled-components";

const PageWrapper: any = styled.div<{topOffset?: number}>`
    width: 100%;
    height: ${(props: any) => 
        `calc(100% - ${props.topOffset ? `${props.topOffset}px` : '0px'})`
    };
    overflow-x: hidden;
    overflow-y: auto;
    background-color: transparent;

    @media(max-width: 550px) {
        height: ${(props: any) => 
            `calc(100dvh - ${props.topOffset ? `${props.topOffset}px` : '0px'})`
        };
    }
`;

export default PageWrapper;